import React, { forwardRef } from 'react'
import Checkbox from 'antd/lib/checkbox'
import type { CheckboxGroupProps as AntdCheckboxGroupProps } from 'antd/lib/checkbox/Group'
import { connectReadonlyComponent } from '../connect'
import { PreviewText } from '../preview-text'

export type CheckboxGroupProps = AntdCheckboxGroupProps & {
  readonly?: boolean
}

export default connectReadonlyComponent(Checkbox.Group, PreviewText.Select)
